import { Pipe, PipeTransform } from '@angular/core';
import { isEqual, startOfDay } from 'date-fns';

@Pipe({
  name: 'isSameDate',
})
export class IsSameDatePipe implements PipeTransform {
  transform(
    value: Date | null | undefined,
    compare: Date | null | undefined,
  ): boolean {
    if (!value && !compare) {
      return true;
    }

    if (!value || !compare) {
      return false;
    }

    return isEqual(startOfDay(value), startOfDay(compare));
  }
}
